import initDebug from 'debug';
import {
  FETCH_HEADER_SUCCESS,
  SHOW,
  HIDE,
  FOCUSED,
  PERSIST_SEARCH,
} from './actionTypes';

const debug = initDebug('canopy:headerAction');

export const show = () => ({
  type: SHOW,
});

export const hide = () => ({
  type: HIDE,
});

export const setFocus = status => ({
  type: FOCUSED,
  payload: status,
});

export const persistHeaderSearch = searchKeywords => ({
  type: PERSIST_SEARCH,
  payload: searchKeywords,
});
export const setIsHome = isHome => (dispatch) => {
  debug('setIsHome start');
  return dispatch({
    type: FETCH_HEADER_SUCCESS,
    payload: {
      isHome,
    },
  });
};

export const setHelpLink = helpLink => (dispatch) => {
  debug('setIsHome start');
  return dispatch({
    type: FETCH_HEADER_SUCCESS,
    payload: {
      helpLink,
    },
  });
};

// Action Creators
// export const fetchHeader = (headersToAdd, isHome, params) => (dispatch) => {
//   debug('fetchHeader start');
//
//   dispatch({ type: FETCH_HEADER_REQUEST });
//   // return fetch("http://localhost:3000/api/Header")
//   //   .then(response => response.json())
//   const techService = new TechService();
//   const config = configService.get();
//   // techService.injectFetch(fetch);
//   // techService.injectErrorLogger(debug);
//   // techService.injectServiceLogger(message => debug(message));
//
//   techService.injectEndpoint(config.backendTechUrl);
//   techService.injectEndpoint(techService.getEndpoint());
//   // call ws to obtain menu data
//
//   return techService.header(headersToAdd, params)
//     .catch((err) => {
//       debug('fetchHeader failure', err);
//       return dispatch({ type: FETCH_HEADER_FAILURE, error: err });
//     })
//     .then((header) => {
//       debug('fetchHeader success', header);
//       if (header.error) {
//         return dispatch({ type: FETCH_HEADER_FAILURE, error: header.error });
//       }
//       return dispatch({
//         type: FETCH_HEADER_SUCCESS,
//         payload: {
//           ...header.data,
//           isHome,
//         },
//       });
//     });
// };
